module.exports = __webpack_public_path__ + "static/img/40.49211f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/40.png
// module id = 3v93
// module chunks = 1